import { render, staticRenderFns } from "./privacyModal.vue?vue&type=template&id=378d65aa&scoped=true&"
import script from "./privacyModal.vue?vue&type=script&lang=js&"
export * from "./privacyModal.vue?vue&type=script&lang=js&"
import style0 from "./privacyModal.vue?vue&type=style&index=0&id=378d65aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378d65aa",
  null
  
)

export default component.exports